import { Swiper, Navigation, Pagination, Scrollbar, EffectCoverflow, Autoplay } from 'swiper';
Swiper.use([Navigation, Autoplay, Pagination, Scrollbar, EffectCoverflow]);

if (document.querySelector('.slider-products')) {
  var container = document.querySelector('.slider-products .swiper-wrapper');
  var pagination = document.querySelector('.slider-products .swiper-pagination');
  var scroll = document.querySelector('.product-slider .js-scroll-container');
  for (var i = container.children.length; i >= 0; i--) {
    var pos = (Math.random() * i) | 0;
    if (container && container.children[pos]) {
      container.appendChild(container.children[pos]);
    }
    if (pagination && pagination.children[pos]) {
      pagination.appendChild(pagination.children[pos]);
    }
    if (scroll && scroll.children[pos]) {
      scroll.appendChild(scroll.children[pos]);
    }
  }

  new Swiper('.slider-products', {
    slideToClickedSlide: true,
    slidesPerView: 'auto',
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    loop: true,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      bulletActiveClass: 'active',
      clickable: true,
      renderBullet: function (index, className) {
        var pagination = this.el.querySelectorAll('.swiper-pagination > *')[index] || false;
        if (pagination) {
          var paginationEl = document.createElement('div');
          paginationEl.innerHTML = pagination.outerHTML;
          paginationEl = paginationEl.firstChild;
          paginationEl.classList.add(className);
          return paginationEl.outerHTML;
        } else {
          return '<div class="pagination col ' + className + '">' + (index + 1) + '</div>';
        }
      },
    },
  });
}

if (document.querySelector('.slider-milestones')) {
  new Swiper('.slider-milestones', {
    slideToClickedSlide: true,
    slidesPerView: 1,
    breakpoints: {
      440: {
        slidesPerView: 2,
        // spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        // spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        // spaceBetween: 50,
      },
      1280: {
        slidesPerView: 5,
        // spaceBetween: 50,
      },
    },
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  }).slideTo(1);
}

if (document.querySelector('.slider-representatives')) {
  var container = document.querySelector('.slider-representatives .swiper-wrapper');
  var pagination = document.querySelector('.slider-representatives .swiper-pagination');
  var scroll = document.querySelector('.representatives-slider .js-scroll-container');
  for (var i = container.children.length; i >= 0; i--) {
    var pos = (Math.random() * i) | 0;
    if (container && container.children[pos]) {
      container.appendChild(container.children[pos]);
    }
    if (pagination && pagination.children[pos]) {
      pagination.appendChild(pagination.children[pos]);
    }
    if (scroll && scroll.children[pos]) {
      scroll.appendChild(scroll.children[pos]);
    }
  }
  new Swiper('.slider-representatives', {
    slideToClickedSlide: true,
    centeredSlides: true,
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      bulletActiveClass: 'active',
      clickable: true,
      renderBullet: function (index, className) {
        var pagination = this.el.querySelectorAll('.swiper-pagination > *')[index] || false;
        if (pagination) {
          var paginationEl = document.createElement('div');
          paginationEl.innerHTML = pagination.outerHTML;
          paginationEl = paginationEl.firstChild;
          paginationEl.classList.add(className);
          return paginationEl.outerHTML;
        } else {
          return '<div class="pagination col ' + className + '">' + (index + 1) + '</div>';
        }
      },
    },
  });
}

window.addEventListener('load', positionCarrusellButtons);
window.addEventListener('resize', positionCarrusellButtons);

function positionCarrusellButtons() {
  document.querySelectorAll('.slider-representatives').forEach((carousell) => {
    var prev = carousell.querySelector('.swiper-button-prev i');
    var next = carousell.querySelector('.swiper-button-next i');
    var centerElement = carousell.querySelector('.swiper-slide');
    var centerHeight = centerElement.clientHeight || 0;
    if (centerHeight > 0) {
      if (prev) {
        prev.style.top = Math.round(centerHeight / 2) - Math.round(prev.clientHeight) / 2 + 'px';
        prev.style.position = 'absolute';
      }
      if (next) {
        next.style.top = Math.round(centerHeight / 2) - Math.round(next.clientHeight) / 2 + 'px';
        next.style.position = 'absolute';
      }
    }
  });
}
